import SearchInput from "../../../components/SearchInput/SearchInput";
import Buttons from "../../../components/Buttons/Buttons";
import { PlusIcon } from "../../../assets/icons-components/Icons";

const AddDeviceHeader = ({ searchQuery, onSearchChange, onAddDevice }) => (
  <div className="mainadd_header1">
    <div className="mainadd_header1_left">
      <SearchInput
        className="mainadd_header1_center_searchbar"
        name="searchQuery"
        placeholder="Search by Device Name, ID or Health Professional"
        value={searchQuery}
        onChange={onSearchChange}
      />
    </div>
    <div className="mainadd_header1_center">
      <div className="mainadd_header1_center_addbtn">
        <Buttons
          text="Add New Device"
          type="button"
          variant="primary"
          fullWidth={false}
          style={{ height: 40 }}
          onClick={onAddDevice}
          icon={<PlusIcon />}
        />
      </div>
    </div>
  </div>
);

export default AddDeviceHeader;
